module.exports = __webpack_public_path__ + "img/sw-b03.45991d3b.png";